import React from 'react';
import './Events.css';

const Events = () => {
  return (
    <div className="events-container">
      <div className="blackText">
        <div className="navbarSpace"></div>
        <h2>Our Calendar</h2>
      </div>

      <iframe
        src="https://calendar.google.com/calendar/embed?src=webmaster.wece%40gmail.com&ctz=America%2FNew_York"
        className="calendar-iframe"
        width="100%"
        height="600"
        frameBorder="0"
        style={{ border: 'solid 1px #777' }}
      ></iframe>
    

      <div className="blackText">
        <p>Join our slack to stay up to date on events and socials</p>
      </div>
    </div>
  );
};

export default Events;